import { Checkbox } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { Collaborator, toggleCollaboratorBlockById } from "src/apis/company";
import { isUserAdministrator } from "src/utils/auth";

type IsBlockedCheckboxCellProps = {
    collaborator: Collaborator
}

const IsBlockedCheckboxCell: FC<IsBlockedCheckboxCellProps> = ({collaborator}) => {
    const [checked, setChecked] = useState<boolean>(collaborator?.bloqueio ?? false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const isAdmin = useMemo(isUserAdministrator, []);

    // O colaborador pode ser desbloqueado fora daqui (ex.: quitação automática
    // das sessões em aberto), então o checkbox acompanha a prop.
    useEffect(() => {
        setChecked(collaborator?.bloqueio ?? false);
    }, [collaborator?.bloqueio]);

    const toggleCollaboratorBlock = async (reason: string): Promise<void> => {
        if (!isAdmin) return;

        setIsLoading(true);

        try {
            await toggleCollaboratorBlockById(collaborator?.id_empresa, collaborator?.id_colaborador, reason)

            setChecked(!checked)
        } catch(err: any) {
            console.error(err)
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Checkbox
            disabled={!isUserAdministrator() || isLoading}
            checked={checked}
            title={isAdmin ? (checked ? "Desbloquear colaborador" : "Bloquear colaborador") : "Colaborador bloqueado?"}
            onClick={() => {
                const action = checked ? "desbloquear" : "bloquear"

                if (window.confirm(`Deseja mesmo ${action} o colaborador ${collaborator?.nome}`)) {
                    const reason = window.prompt(`Por qual motivo deseja ${action} o colaborador ${collaborator?.nome}?`) ?? 'Não informado';

                    toggleCollaboratorBlock(reason)
                }
            }}
        />
    );
}

export default IsBlockedCheckboxCell;
